import { Component } from '@angular/core';
import { CommonFunctionsService } from '../../services/common-functions.service';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  imports: [
    MatCardModule,
    MatButton,
    TranslatePipe
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {

  isLoginInProgress = false;
  isSessionExpired = false;

  constructor(private readonly commonFunctionsService: CommonFunctionsService) {
    try {
      this.isSessionExpired = sessionStorage.getItem(CommonFunctionsService.SESSION_EXPIRED_FLAG) === 'true';
      sessionStorage.removeItem(CommonFunctionsService.SESSION_EXPIRED_FLAG);
    } catch {
      // Ignore storage access errors.
    }
  }

  login(): void {
    if (this.isLoginInProgress) {
      return;
    }

    // Disable the button to prevent double-clicks. The service triggers a
    // full page navigation, so this component instance will be torn down and
    // the flag does not need to be reset here — if navigation fails for some
    // reason, the service logs the error and the user can reload.
    this.isLoginInProgress = true;
    this.commonFunctionsService.login();
  }
}
